module.exports = __webpack_public_path__ + "static/media/addBulk.1d395338.svg";